export default function PageHeader({ title, subtitle, action }) {
  return (
    <div className="bg-white border-b border-neutral-200 px-4 md:px-8 py-4 md:py-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
      <div className="min-w-0">
        <div className="label-eyebrow mb-1 md:mb-2">Magazzino</div>
        <h1 className="font-display font-black text-2xl md:text-3xl tracking-tighter text-neutral-900 truncate">{title}</h1>
        {subtitle && <p className="text-xs md:text-sm text-neutral-500 mt-1">{subtitle}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}
